class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const isSp = window.matchMedia('(max-width: 767px)').matches;

    const createSwiper = () => {
      var worrySwiper = new Swiper(".js-worrySwiper", {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 10,
        loop: true,
        speed: 1000,
      });
      var tutorSwiper = new Swiper(".js-tutorSwiper", {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: true,
        speed: 1000,
        pagination: {
          el: ".js-tutorSwiper-pagination",
          clickable: true,
        },
      });
    }

    if(isSp){
      createSwiper();
    }

    let isClosedByUser = false;

    $(".js-fixed-close").on("click", function () {
      isClosedByUser = true;
      $(".js-fixedBanner").addClass("no-active");
    });
    
    $(window).on("scroll resize", function () {
      const $fixed = $(".js-fixedBanner");
      const $fixedLink = $(".js-fixed-link");
      const $footer = $(".js-footer");
    
      if ($fixed.length === 0 || $footer.length === 0) return;
    
      const fixedBottom = $fixed.offset().top + $fixed.outerHeight();
      const footerTop = $footer.offset().top;
    
      if (fixedBottom >= footerTop) {
        $fixedLink.addClass("no-active");
        if (!isClosedByUser) {
          $fixed.addClass("no-active");
        }
      } else {
        $fixedLink.removeClass("no-active");
        if (!isClosedByUser) {
          $fixed.removeClass("no-active");
        }
      }
    });

    $('.js-acc-trigger').on('click', function(){
      $(this).find('.ic-plus').toggleClass('is-active');
      $(this).next().slideToggle();
    });
    
    
  }
}
